import { mainActions, useAppDispatch } from '@hts/shared/libs';
import { HtsButtonIcon, HtsTypography, HtslIcon } from '@hts/shared/ui';
import React, { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/LinkElement.module.scss';

interface ILinkElementProps {
  type: 'help' | 'faq' | 'signInUp';
  colorType?: 'black' | 'white';
  isJustIconLayout?: boolean;
  isMobile?: boolean;
  onCloseCb?: () => void;
}

export const LinkElement: React.FC<ILinkElementProps> = memo(
  ({ type, colorType = 'black', isJustIconLayout, isMobile = false, onCloseCb }) => {
    const dispatch = useAppDispatch();

    const helpLink = 'https://api.whatsapp.com/send/?phone=%2B17186125052';

    const onClickFaqs = useCallback(() => {
      onCloseCb?.();
      dispatch(mainActions.toggleHeaderPopup());
    }, [dispatch, onCloseCb]);

    if (isJustIconLayout) {
      return (
        <>
          {type === 'help' && (
            <Link to={helpLink} onClick={onCloseCb}>
              <HtslIcon icon="ask-for-help" color={colorType} style={{ width: 30 }} />
            </Link>
          )}

          {type === 'faq' && (
            <HtsButtonIcon className={styles.howItWorksContainer} onClick={onClickFaqs}>
              <HtslIcon icon="faq" color={colorType} style={{ width: 30 }} />
            </HtsButtonIcon>
          )}

          {type === 'signInUp' && (
            <Link to={''}>
              <HtslIcon icon="userCircle" color={colorType} style={{ width: 30 }} />
            </Link>
          )}
        </>
      );
    }

    return (
      <>
        {type === 'help' && (
          <Link to={helpLink} className={styles.linkContainer} onClick={onCloseCb}>
            <div className={styles.needAnyHelpContainer}>
              <HtslIcon
                icon={isMobile ? 'ask-for-help-bold' : 'ask-for-help'}
                color={colorType}
                style={{ width: 30 }}
              />

              <div>
                {isMobile ? (
                  <span style={{ fontWeight: '500', fontSize: 12 }}>Need any help?</span>
                ) : (
                  <HtsTypography variant="subtitle" fontWeight="400" color={colorType}>
                    Need any help?
                  </HtsTypography>
                )}

                {isMobile ? (
                  <span style={{ fontWeight: '500', fontSize: 9 }}>718.612.5052</span>
                ) : (
                  <HtsTypography variant="subtitle" fontWeight="500" color={colorType}>
                    718.612.5052
                  </HtsTypography>
                )}
              </div>
            </div>
          </Link>
        )}

        {type === 'faq' && (
          <HtsButtonIcon className={styles.howItWorksContainer} onClick={onClickFaqs}>
            <HtslIcon icon="faq" color={colorType} style={{ width: 30 }} />

            <HtsTypography variant="subtitle" color={colorType}>
              How it works
            </HtsTypography>
          </HtsButtonIcon>
        )}

        {type === 'signInUp' && (
          <Link to={''} className={styles.linkContainer}>
            <div className={styles.signInUpContainer}>
              <HtslIcon icon="userCircle" color={colorType} style={{ width: 30 }} />

              <HtsTypography variant="subtitle" color={colorType}>
                Sign In / Sign Up
              </HtsTypography>
            </div>
          </Link>
        )}
      </>
    );
  }
);
